/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

export type RefreshEmailEventOneOfOneoneEvent =
  (typeof RefreshEmailEventOneOfOneoneEvent)[keyof typeof RefreshEmailEventOneOfOneoneEvent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefreshEmailEventOneOfOneoneEvent = {
  photo_synced: 'photo_synced',
} as const;
